import Vue from 'vue';
import * as html from './gp-formgroup.html';
import {ValidationProvider} from 'vee-validate';

export default Vue.component('gp-formgroup', {
	render: html.render,
	staticRenderFns: html.staticRenderFns,
	components: {
		ValidationProvider
	},

	data: () => ({
		showTooltipText: false
	}),

	props: {
		customMessages: {
			type: Object,
			required: false
		},
		detectInput: {
			type: Boolean,
			default: true
		},
		label: String,
		labelSubtext: String,
		labelClasses: {
			type: String,
			required: false,
			default: 'mb-0 d-inline grey-accesible'
		},

		mode: {
			type: String,
			default: 'eager'
		},
		name: String,
		rules: [String, Object],
		skipIfEmpty: {
			type: Boolean,
			default: false
		},


		tooltipText: String,
		tooltipTitle: String,
		vid: String,


		// Success / Error overrides
		errorOverride: {
			default: false,
			type: Boolean
		},
		errorText: String,

		successOverride: {
			default: false,
			type: Boolean
		},
		successText: String,

		// adds ability to manually override position of validation checkbox
		validCheckPositionRight: {
			required: false,
			type: Number,
			default: 15
		},

		validCheckPositionTop: {
			required: false,
			type: Number,
			default: 40
		},

		// adds ability to completely hid the validation check icon
		showValidCheck: {
			required: false,
			type: Boolean,
			default: true
		}
	}
});
